(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lease-button"] && !Shopify.designMode) return;
  try {
    (() => {
    const run = (scope) => {
      (scope || document).querySelectorAll('[data-vl-lease-cta]').forEach((el) => {
        const price = Number(el.dataset.price) / 100;
        const n = Number(el.dataset.term) || 12;
        const r = (Number(el.dataset.rate) || 0) / 100 / 12;
        const financed = price * (1 - (Number(el.dataset.down) || 0) / 100);
        const monthly = r ? (financed * r) / (1 - Math.pow(1 + r, -n)) : financed / n;
        const fmt = new Intl.NumberFormat(el.dataset.locale || 'en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
        const out = el.querySelector('[data-vl-monthly]');
        if (out && price) out.textContent = fmt.format(Math.ceil(monthly));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run());
    else run();
    document.addEventListener('shopify:section:load', (e) => run(e.target));
    document.addEventListener('shopify:block:select', () => run());
  })();
  } catch(e) { console.error(e); }
})();

})();
